import { render } from "./CloseRecommend.vue?vue&type=template&id=11c15f94&scoped=true&ts=true"
import script from "./CloseRecommend.vue?vue&type=script&lang=ts"
export * from "./CloseRecommend.vue?vue&type=script&lang=ts"

import "./CloseRecommend.vue?vue&type=style&index=0&id=11c15f94&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c15f94"]])

export default __exports__